import { FC, useMemo } from 'react'

import { Nullable } from 'clickNgo/models/utils'
import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormattedFinance } from '../../../../../../../helpers/getFormattedFinance'
import { TRANSLATION_KEYS } from '../../translations'

import styles from './RetailInfoReadMode.module.scss'

interface IRetailInfoReadModeProps {
  employersCount: Nullable<number>
  salesCount: Nullable<number>
}

export const RetailInfoReadMode: FC<IRetailInfoReadModeProps> = ({
  employersCount,
  salesCount,
}) => {
  const formattedEmployersCount = useMemo(() => {
    if (employersCount === null) {
      return '-'
    }

    return getFormattedFinance(employersCount, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }, [employersCount])

  const formattedSalesCount = useMemo(() => {
    if (salesCount === null) {
      return '-'
    }

    return getFormattedFinance(salesCount, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }, [salesCount])

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{formattedEmployersCount}</div>
        <div className={styles.label}>
          <Translation text={TRANSLATION_KEYS.employersCountLabel} span />
        </div>
      </div>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{formattedSalesCount}</div>
        <div className={styles.label}>
          <Translation text={TRANSLATION_KEYS.salesCountLabel} span />
        </div>
      </div>
    </div>
  )
}
